import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreateCustomDialogService {
  private _isOpen = new BehaviorSubject<boolean>(false);
  private _confirmed = new Subject<void>();

  public isOpen$ = this._isOpen.asObservable();
  public confirmed$ = this._confirmed.asObservable();

  constructor() { }

  openDialog(): void {
    this._isOpen.next(true);
  }

  closeDialog(): void {
    this._isOpen.next(false);
  }

  confirmAction(): void {
    this._confirmed.next();
    this.closeDialog();
  }
}